import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const Container = styled.div`
  padding: 30px;
`;

export const Header = styled.div`
  font-size: 20px;
  line-height: 27px;
`;

export const HeaderTitle = styled.span`
  padding: 0 10px;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 10px;
  top: 25px;
`;

export const MessageLine = styled.div`
  font-size: 14px;
  line-height: 19px;
  margin: 20px 0;
`;

export const StyledParagraph = styled.p`
  font-size: 14px;
  font-weight: 600;
`;
